import { createLazyComponent } from '@luna/utils-ui';

export const LazyDevToolsRequestCounter = createLazyComponent(() =>
    import('./DevToolsRequestCounter' /* webpackChunkName: "DevToolsRequestCounter" */).then(
        ({ DevToolsRequestCounter }) => DevToolsRequestCounter,
    ),
);
